import getStore from 'services/getStore';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';

export default (noop = false) => {
  const { currentInteractionBlockId, focusedNodeId } = getStore().getState();

  if (noop && currentInteractionBlockId === focusedNodeId) {
    return;
  }
  //
  if (currentInteractionBlockId === focusedNodeId) {
    return setCurrentBlock(null);
  }

  if (currentInteractionBlockId) {
    return setCurrentBlock({ id: currentInteractionBlockId });
  }

  setCurrentBlock(null);
};
